var exports = {
  "kL": "SegmentedTabs.module__container___YUF1cF",
  "gj": "SegmentedTabs.module__tabList___YUF1cF",
  "Mf": "SegmentedTabs.module__tab___YUF1cF",
  "DF": "SegmentedTabs.module__tabInactive___YUF1cF",
  "yR": "SegmentedTabs.module__tabActive___YUF1cF",
  "KE": "SegmentedTabs.module__tabBackground___YUF1cF",
};

module.exports = exports;
